// extracted by mini-css-extract-plugin
module.exports = {"empty":"s-empty_empty__1-BLcKMO"};